import { useState } from 'react';
import { message } from 'antd';

import { useLookStock } from 'actions/products';
import { useI18n } from 'context/i18n';
import { useProductSheet } from 'context/product-sheet';
import { useIsMounted } from 'hooks';

import { ShirtSVG } from './iconsSVG/shirt';
import { CheckSVG } from './iconsSVG/check';
import { LoaderCircleSVG } from './iconsSVG/loaderCircle';
import { dataLayerHandleEvent } from 'utils/dataLayers';

export const shopLookHardCoded: Record<string, { sku: string; size: string }[]> = {
  'AU00005-006': [
    { sku: 'AU00005-006', size: 'M' },
    { sku: 'AU00006-006', size: '30' },
  ],
  'AU00002-006': [
    { sku: 'AU00002-006', size: 'M' },
    { sku: 'AU00006-006', size: '30' },
  ],
  'AU00006-006': [
    { sku: 'AU00006-006', size: '30' },
    { sku: 'AU00005-006', size: 'M' },
  ],
  'AU00001-006': [
    { sku: 'AU00001-006', size: 'M' },
    { sku: 'AU00006-006', size: '30' },
  ],
  'AU00005-005': [
    { sku: 'AU00005-005', size: 'M' },
    { sku: 'AU00006-005', size: '30' },
  ],
  'AU00002-007': [
    { sku: 'AU00002-007', size: 'M' },
    { sku: 'AU00006-005', size: '30' },
  ],
  'AU00006-005': [
    { sku: 'AU00006-005', size: '30' },
    { sku: 'AU00005-005', size: 'M' },
    { sku: 'A700016-001', size: ' 40' },
  ],
  'AU00001-007': [
    { sku: 'AU00001-007', size: 'M' },
    { sku: 'AU00006-005', size: '30' },
  ],
  'AU00005-007': [
    { sku: 'AU00005-007', size: 'M' },
    { sku: 'AU00006-007', size: '30' },
  ],
  'AU00002-005': [
    { sku: 'AU00002-005', size: 'M' },
    { sku: 'AU00006-007', size: '30' },
  ],
  'AU00006-007': [
    { sku: 'AU00006-007', size: '30' },
    { sku: 'AU00005-007', size: 'M' },
    { sku: 'A500025-003', size: '40' },
  ],
  'AU00001-005': [
    { sku: 'AU00001-005', size: 'M' },
    { sku: 'AU00006-007', size: '30' },
  ],
  'AU00012-002': [
    { sku: 'AU00012-002', size: 'M' },
    { sku: 'AU00013-002', size: '30' },
  ],
  'AU00013-002': [
    { sku: 'AU00013-002', size: '30' },
    { sku: 'AU00002-005', size: 'M' },
    { sku: 'A500023-002', size: '40' },
  ],
  'AU00010-003': [
    { sku: 'AU00010-003', size: 'M' },
    { sku: 'AU00013-002', size: '30' },
  ],
  'AU00017-003': [
    { sku: 'AU00017-003', size: '' },
    { sku: 'AU00011-002', size: 'M' },
    { sku: 'AU00006-005', size: '30' },
  ],
  'AU00012-001': [
    { sku: 'AU00012-001', size: 'M' },
    { sku: 'AU00013-001', size: '30' },
  ],
  'AU00010-002': [
    { sku: 'AU00010-002', size: 'M' },
    { sku: 'AU00013-001', size: '30' },
  ],
  'AU00013-001': [
    { sku: 'AU00013-001', size: '30' },
    { sku: 'AU00012-001', size: 'M' },
    { sku: 'A500023-003', size: '40' },
  ],
  'AU00017-002': [
    { sku: 'AU00017-002', size: '' },
    { sku: 'AU00011-003', size: 'M' },
    { sku: 'AU00013-001', size: '30' },
  ],
  'AU00011-001': [
    { sku: 'AU00011-001', size: 'M' },
    { sku: 'AU00006-006', size: '30' },
  ],
  'AU00011-002': [
    { sku: 'AU00011-002', size: 'M' },
    { sku: 'AU00006-005', size: '30' },
  ],
  'AU00011-003': [
    { sku: 'AU00011-003', size: 'M' },
    { sku: 'AU00013-001', size: '30' },
  ],
  //nuevos
  'AU00005-003': [
    { sku: 'AU00005-003', size: 'M' },
    { sku: 'AU00006-003', size: '30' },
    { sku: 'A500013-001', size: '40' },
  ],
  'AU00002-004': [
    { sku: 'AU00002-004', size: 'L' },
    { sku: 'AU00007-003', size: '30' },
  ],
  'AU00006-003': [
    { sku: 'AU00006-003', size: '30' },
    { sku: 'AU00005-003', size: 'M' },
    { sku: 'A500013-001', size: '40' },
    { sku: 'AA00002-003', size: 'M' },
  ],
  'AU00001-004': [
    { sku: 'AU00001-004', size: 'S' },
    { sku: 'AU00007-003', size: '30' },
  ],
  'AU00007-003': [
    { sku: 'AU00007-003', size: '30' },
    { sku: 'AU00005-003', size: 'M' },
    { sku: 'A500013-001', size: '40' },
    { sku: 'AA00002-003', size: 'M' },
  ],
  'AU00005-002': [
    { sku: 'AU00005-002', size: 'M' },
    { sku: 'AU00006-002', size: '30' },
    { sku: 'A700007-001', size: '40' },
  ],
  'AU00002-001': [
    { sku: 'AU00002-001', size: 'M' },
    { sku: 'AU00007-002', size: '30' },
  ],
  'AU00006-002': [
    { sku: 'AU00006-002', size: '30' },
    { sku: 'AU00005-002', size: 'M' },
    { sku: 'A700007-001', size: '40' },
  ],
  'AU00001-001': [
    { sku: 'AU00001-001', size: 'S' },
    { sku: 'AU00007-002', size: '30' },
  ],
  'AU00007-002': [
    { sku: 'AU00007-002', size: '30' },
    { sku: 'AU00001-001', size: 'S' },
    { sku: 'A700007-001', size: '40' },
  ],
  'AU00005-004': [
    { sku: 'AU00005-004', size: 'M' },
    { sku: 'AU00006-004', size: '30' },
    { sku: 'A500013-007', size: '40' },
  ],
  'AU00002-002': [
    { sku: 'AU00002-002', size: 'M' },
    { sku: 'AU00007-004', size: '30' },
  ],
  'AU00006-004': [
    { sku: 'AU00006-004', size: '30' },
    { sku: 'AU00005-004', size: 'M' },
    { sku: 'A500013-007', size: '40' },
  ],
  'AU00001-002': [
    { sku: 'AU00001-002', size: 'M' },
    { sku: 'AU00006-004', size: '30' },
  ],
  'AU00007-004': [
    { sku: 'AU00007-004', size: '30' },
    { sku: 'AU00005-004', size: 'M' },
    { sku: 'AA00002-004', size: 'M' },
    { sku: 'A500013-007', size: '40' },
  ],
  'AU00005-001': [
    { sku: 'AU00005-001', size: 'M' },
    { sku: 'AU00006-001', size: '30' },
    { sku: 'A700005-007', size: '39' },
  ],
  'AU00002-003': [
    { sku: 'AU00002-003', size: 'M' },
    { sku: 'AU00006-001', size: '30' },
  ],
  'AU00006-001': [
    { sku: 'AU00006-001', size: '30' },
    { sku: 'AU00005-001', size: 'M' },
    { sku: 'A700005-007', size: '39' },
  ],
  'AU00001-003': [
    { sku: 'AU00001-003', size: 'M' },
    { sku: 'AU00006-001', size: '30' },
  ],
  'AU00007-001': [
    { sku: 'AU00007-001', size: '30' },
    { sku: 'AU00005-001', size: 'M' },
    { sku: 'A700005-007', size: '39' },
  ],
  'AU00004-002': [
    { sku: 'AU00004-002', size: '30' },
    { sku: 'AU00003-004', size: '30' },
    { sku: 'A700005-007', size: '39' },
  ],
  'AU00003-004': [
    { sku: 'AU00003-004', size: '30' },
    { sku: 'AU00004-002', size: '30' },
    { sku: 'A700005-007', size: '39' },
  ],
  'AU00004-001': [
    { sku: 'AU00004-001', size: 'M' },
    { sku: 'AU00003-003', size: '30' },
    { sku: 'A700005-001', size: '40' },
  ],
  'AU00003-003': [
    { sku: 'AU00003-003', size: '30' },
    { sku: 'AU00004-001', size: 'M' },
    { sku: 'A700005-001', size: '40' },
  ],
};

export const availableLookSkus = Object.keys(shopLookHardCoded);

export function ShopLook({ primarySku }: { primarySku: string }) {
  const { bag, t } = useI18n();
  const { productSheet } = useProductSheet();
  const isMounted = useIsMounted();
  const { data } = useLookStock({
    primarySku,
    skus: shopLookHardCoded[primarySku].map((s) => s.sku),
    target: productSheet.target,
  });
  const [status, setStatus] = useState<'idle' | 'pending' | 'resolved'>('idle'); // idle, pending, resolved,

  const handleAddToCartLook = async () => {
    try {
      // si no hay datos va a fallar el addToCartMultiple
      if (!data) {
        message.error('Error adding to cart');
        return;
      }
      dataLayerHandleEvent({
        event: 'item_photos',
        event_category: 'product detail',
        event_detail_1: 'shop the look',
        event_detail_2: primarySku, // codigo de producto principal
      });
      setStatus('pending');
      const skusToAdd = shopLookHardCoded[primarySku].map((s) => {
        const skuStock = data[s.sku].sizes;
        if (skuStock) {
          let sizeToAdd = skuStock.find((size) => size.value === s.size && size.available);
          if (!sizeToAdd) {
            sizeToAdd = skuStock.find((size) => size.available);
          }
        }
        return {
          sku: s.sku,
          size: skuStock?.value ?? s.size,
          price: data[s.sku].prices,
        };
      });
      await window.addToCartMultiple(skusToAdd, false, bag);
      if (isMounted()) {
        setStatus('resolved');
      }
    } catch (e) {
      if (isMounted()) {
        setStatus('idle');
        message.error('Error adding to cart');
      }
    }
  };

  return (
    <button
      disabled={!data || status === 'pending'}
      className="absolute right-4 top-4 z-10 flex items-center justify-center gap-2 rounded border border-[#e5e7eb] bg-[var(--color-white)] px-3 py-2 text-xs shadow transition-all duration-300"
      onClick={handleAddToCartLook}
    >
      {status === 'resolved' ? t('ficha.producto', 'notificacion.bolsa') : t('ficha.producto', 'shop.look')}
      {status === 'idle' ?
        <ShirtSVG className="size-4 text-[#374151]" />
      : null}
      {status === 'resolved' ?
        <CheckSVG className="size-4 text-[var(--color-success)]" />
      : null}
      {status === 'pending' ?
        <LoaderCircleSVG className="size-4 animate-spin" />
      : null}
    </button>
  );
}
